import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { IconCopy, IconCheck } from '@tabler/icons-react';

import Button from '../buttons/Button';

/** Read-only invite URL with a Copy button that confirms for 2 seconds. */
const InviteLinkBox = ({ inviteUrl }) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return undefined;
    const timer = setTimeout(() => setCopied(false), 2000);
    return () => clearTimeout(timer);
  }, [copied]);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(inviteUrl);
    setCopied(true);
  };

  return (
    <div className="flex items-center space-x-2 rounded-lg bg-gray-10 py-2 pl-3 pr-2">
      <input
        aria-label="Invite link"
        readOnly
        value={inviteUrl}
        onFocus={(e) => e.target.select()}
        className="min-w-0 flex-1 truncate border-0 bg-transparent p-0 text-sm text-gray-800 focus:ring-0"
      />
      <Button
        title={copied ? 'Copied' : 'Copy'}
        size="sm"
        color="primary"
        LeftIcon={copied ? IconCheck : IconCopy}
        iconProps={{ size: 16 }}
        onClick={handleCopy}
      />
    </div>
  );
};

InviteLinkBox.propTypes = {
  inviteUrl: PropTypes.string.isRequired,
};

export default InviteLinkBox;
